export default __webpack_public_path__ + "static/media/swap.3eed278a.svg";